import { render, staticRenderFns } from "./VueMarkdown.vue?vue&type=template&id=56ccfbf1&"
import script from "./VueMarkdown.vue?vue&type=script&lang=js&"
export * from "./VueMarkdown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports